// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__IBTED","loadingWrap":"styles_loadingWrap__v+8-Y"};